import React, { useState } from 'react';
import Checker   from './pages/Checker';
import Portfolio from './pages/Portfolio';

const DEFAULT_SHOPIFY = [
  'https://alirazapatel.com/',
  'https://starkesoundaudio.com/',
  'https://thaynne.com/',
  'https://cookiecad.com/',
  'https://www.lazylemon.no/',
  'https://harisluggage.pk/'
];

const DEFAULT_WP = [
  'https://orientsoftsolutions.com/',
  'https://brightsparkliving.org/',
  'https://blackfostercarersalliance.co.uk/',
  'https://firstaidksa.com/',
  'https://viraledge.com.pk/',
  'https://eldersquare.com/',
  'https://dynamicstrategicadvisory.com/',
  'https://cj-optik.sa/',
  'https://spisekammerhalsnaes.dk/'
];

export default function App() {
  const [tab, setTab]             = useState('checker');
  const [shopifyLinks, setShopify] = useState(DEFAULT_SHOPIFY);
  const [wpLinks, setWp]           = useState(DEFAULT_WP);

  function handleSavePortfolio(newShopify, newWp) {
    setShopify(newShopify);
    setWp(newWp);
  }

  return (
    <div className="app">
      <div className="header">
        <h1>Job Checker</h1>
        <span className="header-badge">Top Rated · Shopify & WordPress</span>
      </div>
      <div className="header-sub">Shopify & WordPress — Top Rated on Upwork</div>

      <div className="tabs">
        <button
          className={`tab ${tab === 'checker' ? 'active' : ''}`}
          onClick={() => setTab('checker')}
        >
          Checker
        </button>
        <button
          className={`tab ${tab === 'portfolio' ? 'active' : ''}`}
          onClick={() => setTab('portfolio')}
        >
          Portfolio
        </button>
      </div>

      {tab === 'checker' && (
        <Checker shopifyLinks={shopifyLinks} wpLinks={wpLinks} />
      )}
      {tab === 'portfolio' && (
        <Portfolio
          shopifyLinks={shopifyLinks}
          wpLinks={wpLinks}
          onSave={handleSavePortfolio}
        />
      )}

      <div className="footer">© All rights reserved by Abbas Ali</div>
    </div>
  );
}
